import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import CardComponent, { HistogramIcon, QuestionIcon, UnlockIcon } from "../card-component";
import ChatInterface from "../chat-bot-component";
import { useChat } from '../../index';

export default function CenterPanel() {
    const { selectedPrevMessage } = useChat();
    const [convStarted, setConvStarted] = useState(false);
    const cards = [
        {
            icon: <HistogramIcon />,
            heading: <Typography variant="h5" fontWeight={600} component="div" sx={{ mb: 1.5 }}>Generate Custom Data <br/>Charts</Typography>,
            subHeading: "Use to generate all data"
        },
        {
            icon: <QuestionIcon />,
            heading: <Typography variant="h5" fontWeight={600} component="div" sx={{ mb: 1.5 }}>Ask CAN Data <br/> Question</Typography>,
            subHeading: "Get CAN Related Data in Seconds"
        },
        {
            icon: <UnlockIcon />,
            heading: <Typography variant="h5" fontWeight={600} component="div" sx={{ mb: 1.5 }}>Unlock ability for <br/>Analysis of CAN Data</Typography>,
            subHeading: "Create ability to analysis CAN Data with out technical knowledge"
        }
    ]

    useEffect(() => {
        if(selectedPrevMessage?.length > 0) setConvStarted(true);
    }, [selectedPrevMessage])

  return (
    <div>
        <div id="heading" style={{ padding: "36px" }}>
        <Typography fontWeight={900} fontSize={36}>CANChat Vehicle Analytics</Typography>
        {(!convStarted) && <Typography fontWeight={500} fontSize={32}>Save time , Use CANVA to do Data Work </Typography>}
        </div>
        {(!convStarted) && <div id="centerCards" style={{ display: "flex", justifyContent: "space-evenly", paddingTop: "2%" }}>
            {cards?.map((item, index) => {
                return(
                    <CardComponent key={index}  {...item} />
                )
            })}
        </div>}
     <div id="chatContainer" style={{ paddingTop: '4%', position: "absolute", bottom: "36px", width: '75%' }}><ChatInterface setConvStarted={setConvStarted} /></div>
    </div>
  );
}
